var _path, _rect, _rect2, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 748,
    height: 538,
    viewBox: "0 0 748 538",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M349.142 513.132L349.337 332.632L369.962 158.484C332.996 126.611 259.831 61.135 250.634 57.5251C241.438 53.9151 226.798 59.9994 222.628 62.9949C157.57 116.924 25.7519 226.182 18.9458 231.775C10.4383 238.765 -0.570916 247.253 0.41123 263.755C1.19695 276.955 9.38363 289.264 13.3788 293.769C105.628 371.368 291.326 527.469 296.122 531.075C300.918 534.68 309.116 536.922 312.615 537.592C340.213 539.622 348.465 522.131 349.142 513.132Z",
    fill: "url(#paint0_linear_11638_60317)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 250.729,
    y: 219.727,
    width: 328.007,
    height: 399.741,
    rx: 47,
    transform: "rotate(-46.5751 250.729 219.727)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 250.729,
    y: 219.727,
    width: 328.007,
    height: 399.741,
    rx: 47,
    transform: "rotate(-46.5751 250.729 219.727)",
    fill: "url(#paint1_linear_11638_60317)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M271.536 88.9409C271.873 86.1005 270.349 77.3093 261.562 64.8672C326.67 119.414 459.582 231.417 470.37 243.059C481.157 254.701 483.838 272.317 483.83 279.669L483.671 426.554C483.657 439.387 487.317 445.608 489.149 447.114C434.033 400.599 320.603 305.06 307.814 295.02C291.827 282.47 276.348 262.902 271.37 242.844C267.387 226.797 269.822 133.556 271.536 88.9409Z",
    fill: "#49E8FD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11638_60317",
    x1: 240.572,
    y1: 56.8444,
    x2: 185.083,
    y2: 537.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0157FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B0D1F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11638_60317",
    x1: 394.19,
    y1: 289.024,
    x2: 365.088,
    y2: 596.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00631324,
    stopColor: "#FFD46B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.923403,
    stopColor: "#F69D0C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.bb232660308be894b41cd006c51b088d.svg";
export { ForwardRef as ReactComponent };